
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(150|806|92)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
